import {hpFundamentalContrastTheme} from '@hconnect/uikit/src/lib2'
import {ThemeProvider} from '@mui/material'
import React from 'react'

/**
 * Wraps filter regions rendered on the blue primary surface (legacy apps) in the
 * Fundamental `ThemeLightBlueContrast` MUI theme, so token-based filter styles
 * (`text.primary`, `divider`, ...) resolve to the on-blue colours automatically.
 *
 * Suite features render on the light page surface and must NOT wrap: their
 * ambient theme already resolves the same tokens to the correct foreground.
 * `isContrastMode` defaults to `true`; pass `false` to render children unchanged
 * (used where the surface is decided at runtime, e.g. shared Suite/legacy pages).
 */
export const FilterContrastProvider: React.FC<{
  isContrastMode?: boolean
  children: React.ReactNode
}> = ({isContrastMode = true, children}) =>
  isContrastMode ? (
    <ThemeProvider theme={hpFundamentalContrastTheme}>{children}</ThemeProvider>
  ) : (
    <>{children}</>
  )
